/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Box } from "@chakra-ui/core";
import { Link } from "gatsby-plugin-intl";

export default ({ children, href, ...rest }) => {
  return (
    <Box
      as={Link}
      d="block"
      mt={4}
      mb={4}
      to={href}
      textDecoration="underline"
      _hover={{ textDecoration: "none" }}
      {...rest}
    >
      {children}
    </Box>
  );
}
